import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './auxiliares/guards/loging.guard';
import { LoginService } from './modulos/login/login.service';

// La sesión se decide en runtime (LoginService: la de la pestaña o la compartida por usuario).
// Cuando el videowall del cliente vuelve a la escena de INSIDEht recarga la URL base:
// si '' redirige a login sin mirar la sesión, la pared termina en la pantalla de login
// con el token todavía válido al lado. Por eso el destino inicial se decide en runtime.
const destinoInicial = (): string =>
  LoginService.getToken() ? '/main/landing' : '/login';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: destinoInicial },
  {
    path: 'login',
    loadChildren: () =>
      import('./modulos/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'main',
    canActivate: [LoginGuard],
    loadChildren: () =>
      import('./modulos/navigation/navigation.module').then(
        (m) => m.NavigationModule,
      ),
  },
  // Sin wildcard, una URL desconocida (deep link viejo, typo en la config de una escena)
  // no aterriza en ninguna ruta y la app queda en blanco.
  {
    // Link del mail de confirmación: pública, con o sin sesión.
    path: 'verificar-email',
    loadComponent: () =>
      import('./modulos/login/verificar-email/verificar-email.component').then(
        (m) => m.VerificarEmailComponent,
      ),
  },
  { path: '**', redirectTo: destinoInicial },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
